import { render, staticRenderFns } from "./Pazar12.vue?vue&type=template&id=1e3dee6e"
import script from "./Pazar12.vue?vue&type=script&lang=js"
export * from "./Pazar12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports